export default "/corgi/pageapps/purchase/_next/static/media/energy-tag-range-old.7643e1d5.svg";